<template>
  <v-dialog
    v-model="dialogProxy"
    width="600"
    scrollable
    persistent
    eager
    @keydown.esc="close"
    @click:outside="close"
  >
    <v-card class="app-card card-borderless">
      <gg-toolbar @close="close">
        Disable Protection
      </gg-toolbar>
      <v-card-text class="pt-2 pb-3">
        <v-row>
          <v-col cols="12">
            You are going to disable protection for "{{ path }}". Please, confirm your action.
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-content-end pb-4 pt-0">
        <gg-btn :loading="loading" @click="removeProtection">Confirm</gg-btn>
        <gg-btn secondary @click="close">Cancel</gg-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import amapi from '@/api/amapi'

export default {
  name: 'RemoveAuthModal',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      required: true,
      type: Boolean
    },
    path: {
      type: String,
      default: ''
    },
    authname: {
      type: String,
      default: ''
    }
  },
  computed: {
    dialogProxy: {
      get () {
        return this.value
      },
      set (val) {
        if (!val) {
          this.$emit('close')
        }
        this.$emit('change', val)
      }
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    ...mapActions({
      reportError: 'reportError',
      reportSuccess: 'reportSuccess'
    }),
    async removeProtection () {
      const data = {
        uapi_module: 'DirectoryPrivacy',
        uapi_function: 'configure_directory_protection',
        dir: this.path,
        enabled: 0,
        authname: this.authname,
        _username: this.$route.query.user,
      }
      this.loading = true
      try {
        await amapi.cpanel_uapi(data)
        this.reportSuccess(`Protection successfully disabled for "${this.path}".`)
        this.$emit('removed')
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
      this.close()
    },
    close () {
      this.dialogProxy = false
    }
  }
}
</script>
